import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Formik, Form } from 'formik';
import {
  TextField,
  TextAreaField,
  SelectFieldV2,
  FileField,
  CheckBoxField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';

import { useNavigate } from 'react-router-dom';
import routes from 'app/routes';

import resourceTypes from 'data/resource_types';
import userRoles from 'data/user_roles';

import useResourceCategories from 'components/Common/ResourceCategories/Hooks/useResourceCategories';

export default function Index({ resource, onSave }) {
  const navigate = useNavigate();

  const { resourceCategories } = useResourceCategories();

  const validation = {
    title: Yup.string().required('Title is required'),
    typeResource: Yup.string().required('Type is required'),
    url: Yup.string().when(['typeResource'], {
      is: (typeResource) => typeResource === 'url',
      then: Yup.string().required('Url is required'),
    }),
    vimeo: Yup.string().when(['typeResource'], {
      is: (typeResource) => typeResource === 'vimeo',
      then: Yup.string().required('Url is required'),
    }),
  };

  if (resource == null) {
    validation.file = Yup.mixed().when(['typeResource'], {
      is: (typeResource) => typeResource === 'file',
      then: Yup.mixed().required('File is required'),
    });
    validation.preview = Yup.mixed().required('Preview is required');
  }

  const FormSchema = Yup.object().shape(validation);

  const formData = {
    title: resource == null ? '' : resource.attributes.title,
    description: resource == null ? '' : resource.attributes.description,
    position: resource == null ? '' : resource.attributes.position,
    typeResource: resource == null ? '' : resource.attributes.type_resource,
    file: undefined,
    url: resource == null ? '' : resource.attributes.url,
    vimeo: resource == null ? '' : resource.attributes.vimeo,
    category_ids: resource == null ? [] : resource.attributes.category_ids,
    preview: undefined,
    managerPromote: resource == null ? false : resource.attributes.manager_promote,
    userRoles: resource == null ? [] : resource.attributes.user_roles,
  };

  const openList = () => {
    navigate(routes.admin.resources.index);
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    onSave(values, () => {
      setSubmitting(false);
      openList();
    }, (errors) => {
      const newErrors = {};
      errors.errors.forEach((item) => {
        newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={FormSchema}
      initialValues={formData}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values }) => (
        <Form className="needs-validation" noValidate="">
          <TextField
            name="title"
            label={(
              <>
                <span>Title</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />
          <TextAreaField
            name="description"
            label={(
              <span>Description</span>
            )}
            style={{ resize: 'vertical' }}
          />
          <TextField
            name="position"
            label={(
              <span>Position</span>
            )}
          />

          <SelectFieldV2
            name="typeResource"
            placeholder="Choose Resource Type"
            isMulti={false}
            options={resourceTypes}
            label={(
              <>
                <span>Resource Type</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />

          <SelectFieldV2
            name="userRoles"
            placeholder="Choose User Roles"
            isMulti
            options={userRoles}
            label={(
              <span>User Roles</span>
            )}
          />

          {values.typeResource === 'file' && (
          <FileField
            name="file"
            label={(
              <>
                <span>File</span>
                <abbr title="required">*</abbr>
              </>
              )}
          />
          )}

          {values.typeResource === 'file' && resource !== null && (
            <div>
              <a
                href={resource.attributes.file_url}
                target="_blank"
                rel="noreferrer"
              >
                {resource.attributes.file_name}
              </a>
            </div>
          )}

          {values.typeResource === 'url' && (
          <TextField
            name="url"
            label={(
              <>
                <span>Url</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />
          )}

          {values.typeResource === 'vimeo' && (
            <>
              <TextField
                name="vimeo"
                label={(
                  <>
                    <span>Vimeo</span>
                    <abbr title="required">*</abbr>
                  </>
            )}
              />

              <div className="checkbox">
                <CheckBoxField
                  name="managerPromote"
                  label={(
                    <span>Welcome Heading</span>
                  )}
                />
              </div>
            </>

          )}

          <FileField
            name="preview"
            label={(
              <>
                <span>Preview</span>
                <abbr title="required">*</abbr>
              </>
              )}
          />
          {resource && resource.attributes.preview_url !== '' && (
            <div>
              <img src={resource.attributes.preview_url} alt="preview" width="200px" />
            </div>
          )}

          {resourceCategories === null && <div>Load Categories ...</div>}
          {resourceCategories && resourceCategories.map((category) => (
            <div className="checkbox" key={category.id}>
              <CheckBoxField
                name="category_ids"
                value={category.id}
                label={(
                  <span>{category.attributes.title}</span>
                )}
              />
            </div>
          ))}

          <div className="text-center mt50 mb30">
            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={openList}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              disabled={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}

Index.propTypes = {
  resource: PropTypes.object,
  onSave: PropTypes.func,
};

Index.defaultProps = {
  resource: null,
  onSave: () => {},
};
